<div [formGroup]="parentGroup">
  <mat-form-field appearance="fill"
    [ngClass]="{'invisible':formElement.hidden === 'true'}">
    <mat-label>
      {{ formElement.text }}
      <span class="sr-only" *ngIf="isFieldDisabled()">{{ getDisabledReadOnlyAnnouncement() }}</span>
    </mat-label>
  
    <input matInput [matDatepicker]="picker" [formControlName]="formElement.formControl" [attr.aria-disabled]="isFieldDisabled()" [attr.aria-readonly]="readOnly">
    <span fxLayout="row" matSuffix>
      <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
    </span>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
